import { createTenantManagementRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';

const tenantRequest = createTenantManagementRequest();

export interface AuthorizedResourceAction {
  name: string;
  description?: string;
}

export interface AuthorizedResource {
  effect?: string;
  code: string;
  type?: string;
  condition?: unknown;
  description?: string | null;
  actions?: string[];
  apiIdentifier?: string | null;
  namespaceId?: number | null;
}

export async function getMyAuthorizedResources(
  appId: string,
  options?: ApiRequestOptions,
) {
  return tenantRequest<AuthorizedResource[]>(`bff/permission/me/authorized-resources`, {
    method: 'GET',
    params: { appId },
    ...(options || {}),
  });
}

export interface NamespaceApp {
  id: number;
  userpoolId: string;
  name: string;
  code: string;
  description: string;
  status: number;
  appId: string;
  appName: string;
  tenantId: string;
}

export async function getPermissionNamespaces(
  options?: ApiRequestOptions,
) {
  return tenantRequest<NamespaceApp[]>(`bff/permission/namespaces`, {
    method: 'GET',
    ...(options || {}),
  });
}
